var map = {
	"./about.json": 1789,
	"./awards.json": 1790,
	"./banking.json": 1791,
	"./broadband.json": 1792,
	"./car-insurance.json": 1793,
	"./careers.json": 1794,
	"./credit-cards.json": 1795,
	"./currents.json": 1796,
	"./energy.json": 1797,
	"./health-insurance.json": 1798,
	"./home-insurance.json": 1799,
	"./homepage.json": 1800,
	"./income-protection.json": 1801,
	"./insurance.json": 1802,
	"./judges.json": 1803,
	"./life-insurance.json": 1804,
	"./lifetime-loans.json": 1805,
	"./loans.json": 1806,
	"./market-analysis.json": 1807,
	"./mortgage-protection.json": 1808,
	"./mortgages.json": 1809,
	"./nominees.json": 1810,
	"./partners.json": 1811,
	"./prepaid-credit-cards.json": 1812,
	"./press.json": 1813,
	"./reasons-why.json": 1814,
	"./savings.json": 1815,
	"./serious-illness.json": 1816,
	"./speed-test.json": 1817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1788;